import React, { useEffect, useState } from "react";
import { Box, Dialog, Button, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import Swal from 'sweetalert2';

// Function to detect iOS devices
const isIosDevice = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

// Function to check if app is in standalone mode
const isInStandaloneMode = () => window.matchMedia("(display-mode: standalone)").matches || navigator.standalone;

const PWAInstaller = ({ promptNew, setPromptNew }) => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);
  const [isIos, setIsIos] = useState(isIosDevice());
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setSupportsPWA(true);
      setPromptInstall(e);
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  useEffect(() => {
    let pressedNo = parseInt(localStorage.getItem("PressedNo")) || 0;
    let dismissedIosPrompt = localStorage.getItem("DismissedIosPrompt") === "true";
    let installPromptDisabled = localStorage.getItem("InstallPromptDisabled") === "true";

    if (!isInStandaloneMode() && !installPromptDisabled) {
      if (isIos && !dismissedIosPrompt) {
        Swal.fire({
          text: 'آیا مایل به نصب برنامه هستید؟',
          showCloseButton: true,
          showCancelButton: true,
          cancelButtonText: 'خیر',
          confirmButtonText: 'بله',
          confirmButtonColor: '#1A9D2F',
          cancelButtonColor: '#d33',
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => setOpen(true), 300); // DELAY TO PREVENT DOUBLE MODAL
            setPromptNew(false);
            localStorage.setItem("InstallPromptDisabled", "true");
          } else {
            pressedNo += 1;
            localStorage.setItem("PressedNo", pressedNo);
            if (pressedNo >= 3) {
              localStorage.setItem("InstallPromptDisabled", "true");
            }
          }
        });
      } else if (promptInstall && pressedNo < 3) {
        Swal.fire({
          text: 'آیا مایل به نصب برنامه هستید؟',
          showCloseButton: true,
          showCancelButton: true,
          cancelButtonText: 'خیر',
          confirmButtonText: 'بله',
          confirmButtonColor: '#1A9D2F',
          cancelButtonColor: '#d33',
        }).then((result) => {
          if (result.isConfirmed) {
            promptInstall.prompt();
            setPromptNew(false);
            localStorage.setItem("InstallPromptDisabled", "true");
          } else {
            pressedNo += 1;
            localStorage.setItem("PressedNo", pressedNo);
            if (pressedNo >= 3) {
              localStorage.setItem("InstallPromptDisabled", "true");
            }
          }
        });
      }
    }
  }, [promptInstall, promptNew, isIos]);

  const handleClose = () => {
    localStorage.setItem("DismissedIosPrompt", "true");
    setOpen(false);
  };

  return (
    <>
      {isIos && (
        <Dialog open={open} onClose={handleClose} sx={{ padding: '1rem' }}>
          <DialogActions>
            <Button onClick={handleClose} autoFocus sx={{ color: '#ccc' }}>
              <ClearIcon />
            </Button>
          </DialogActions>
          <DialogContent>
            <DialogContentText sx={{ fontWeight: '600', textAlign: "left" }}>
              <ul style={{ listStyle: 'none', marginRight: '-1.5rem' }} className="helping text-light">
                <li>1- برنامه حتما در مرورگر سافاری باز شود.</li><br />
                <li>2- در نوار پایین روی دکمه <strong>Share</strong> تپ کنید.</li><br />
                <li>3- در منوی بازشده، گزینه <strong>Add to Home Screen</strong> را انتخاب کنید.</li><br />
                <li>4- در مرحله بعد روی <strong>Add</strong> تپ کنید.</li>
              </ul>
            </DialogContentText>
            <Box display='flex' sx={{ mt: 3 }} justifyContent='center'>
              <Button onClick={handleClose} variant="contained">بستن</Button>
            </Box>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default PWAInstaller;
